export function shouldUpdateTokenExpiration(incomingExpiration) {
  if (!incomingExpiration) {
    return false;
  }

  const incomingDate = new Date(incomingExpiration);
  if (Number.isNaN(incomingDate.getTime())) {
    return false;
  }

  const currentExpiration = localStorage.getItem("token_exp");
  if (!currentExpiration) {
    return true;
  }

  const currentDate = new Date(currentExpiration);
  if (Number.isNaN(currentDate.getTime())) {
    return true;
  }

  return incomingDate.getTime() > currentDate.getTime();
}
